export const TYPES = [
  ["mailer", "Caja mailer"],
  ["shipping_box", "Caja de envío corrugada"],
  ["folding_carton", "Caja plegadiza"],
];
export function brief(input) {
  const type = TYPES.find(([id]) => id === input.type)?.[1] || input.type;
  return `${type}\nMedidas interiores: ${input.length} × ${input.width} × ${
    input.height
  } ${input.dimensionUnit}\nMaterial: ${input.material}\nImpresión: ${
    {
      none: "Sin impresión",
      outside: "Exterior",
      inside: "Interior",
      both: "Exterior e interior",
    }[input.printing]
  }\nCantidad: ${input.quantity} · Diseños: ${input.designs}\nDestino: ${
    input.destinationCountry
  }${input.destinationPostalCode ? " " + input.destinationPostalCode : ""}${
    input.neededBy ? "\nFecha requerida: " + input.neededBy.slice(0, 10) : ""
  }${
    input.notes ? "\nRequisitos adicionales: " + input.notes : ""
  }\nConfirmar material, resistencia, troquel, cargos de preparación, impuestos, flete y plazo.`;
}
export function amount(value) {
  if (typeof value !== "string" || !/^\d{1,10}(?:\.\d{1,4})?$/.test(value))
    return null;
  const number = Number(value);
  return Number.isFinite(number) && number >= 0 ? number : null;
}
export function manualQuote(draft, quantity, now = new Date().toISOString()) {
  const subtotal = amount(draft.subtotal),
    shipping = draft.shipping === "" ? null : amount(draft.shipping),
    tax = draft.tax === "" ? null : amount(draft.tax),
    setup =
      draft.setup === "" || draft.setup == null ? null : amount(draft.setup);
  if (
    subtotal === null ||
    subtotal <= 0 ||
    !Number.isInteger(quantity) ||
    quantity <= 0 ||
    !["USD", "CAD", "ARS", "MXN", "EUR"].includes(draft.currency) ||
    (draft.shipping !== "" && shipping === null) ||
    (draft.tax !== "" && tax === null) ||
    (draft.setup != null && draft.setup !== "" && setup === null)
  )
    throw Error(
      "Indica un total positivo y revisa moneda, preparación, impuestos y flete. Deja vacíos los importes desconocidos."
    );
  return {
    subtotal: draft.subtotal,
    currency: draft.currency,
    setup: setup === null ? null : draft.setup,
    shipping: draft.shipping === "" ? null : draft.shipping,
    tax: draft.tax === "" ? null : draft.tax,
    landedTotal:
      shipping === null || tax === null || setup === null
        ? null
        : (Math.round((subtotal + setup + shipping + tax) * 100) / 100).toFixed(
            2
          ),
    observedAt: now,
    match: draft.confirmed ? "user_confirmed" : "needs_review",
    notes: draft.notes || "",
    source: "manual",
    quantity,
  };
}
export function snapshot(data, manual) {
  return {
    version: 1,
    exportedAt: new Date().toISOString(),
    persisted: false,
    requestId: data.requestId,
    specification: data.input,
    results: data.results.map((result) => ({
      supplierId: result.id,
      supplier: result.name,
      sourceUrl: result.url,
      status: result.status,
      quote: result.quote || manual[result.id]?.saved || null,
    })),
    notice:
      "Comparación interna. Confirmar especificaciones, troquel y costo entregado antes de emitir una cotización firme. No autoriza pedidos.",
  };
}
